import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ViewService {

  viewid: number
  groupid: number

  constructor(private http: HttpClient) { }

  getView(): Observable<any> {
    return this.http.get<any>(`${environment.api}/${this.groupid}/view/${this.viewid}`)
  }
  getData(keys): Observable<any> {
    if (!keys) {
      keys = [{}]
    }
    const headers = new HttpHeaders({
      'keys': JSON.stringify(keys)
    });
    return this.http.get<any>(
      `${environment.api}/${this.groupid}/view/${this.viewid}/data`,
      { headers: headers }
    )

  }
  getParam(): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/${this.groupid}/view/${this.viewid}/params`
    )
  }
  setParam(params: any): Observable<any> {
    return this.http.post<any>(
      `${environment.api}/${this.groupid}/view/${this.viewid}/params`
      , { details: [params] }
    )
  }

}
